import { useState } from "react";
import AdminButton from "../../../core/admin/adminButton";
import AdminModal from "../../../core/admin/adminModal";
import AdminToast from "../../../core/admin/adminToast";
import AdminTabs from "../../../core/admin/adminTabs";
import AdminDetails from "../../../core/admin/adminDetails";
import AdminBadge from "../../../core/admin/adminBadge";
import AdminWatchSpecs from "../../../core/admin/adminWatchSpecs";
import { ImageIcon } from "../../../../img/svg/adminIcons";
import { IWatch } from "../watches/adminWatches";

export default function CandidateWatchModal({ watch, close, handleBanner, banners, refresh }: { watch: IWatch, close: () => void, handleBanner: (watchId: IWatch) => Promise<boolean | null>, banners: string[], refresh: () => Promise<void> }) {

    const [tab, setTab] = useState<"summary" | "details">("summary");
    const [goodToast, setGoodToast] = useState(false);
    const [badToast, setBadToast] = useState(false);
    const [loading, setLoading] = useState(false);

    const doHandleBanner = async () => {
        try {
            setLoading(true);
            const bannerPromise = await handleBanner(watch);
            if (bannerPromise) {
                setGoodToast(true);
                setLoading(false);
                await refresh();
                close();
                return null;
            }
            setBadToast(true);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    const isBanner = banners.includes(watch.id);
    const displayImage = watch?.images?.length ? watch?.images[0].cImgUrl : undefined;

    return (
        <AdminModal
            close={close}
            size="lg"
            title={`${watch?.brand || ""} ${watch?.model || ""}`}
            subtitle={<span className="flex flex-wrap items-center gap-2">Ano {watch?.year} {isBanner ? <AdminBadge tone="gold" dot>Banner</AdminBadge> : <AdminBadge>Não é banner</AdminBadge>}</span>}
            tabs={<AdminTabs value={tab} onChange={setTab} tabs={[{ value: "summary", label: "Resumo" }, { value: "details", label: "Detalhes" }]} />}
            footer={
                tab === "summary" ?
                    <AdminButton variant={watch.isBanner ? "danger" : "primary"} loading={loading} onClick={doHandleBanner}>{watch.isBanner ? "Remover banner" : "Tornar banner"}</AdminButton>
                    : undefined
            }
        >
            {
                tab === "summary" ?
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="md:w-[300px] shrink-0">
                            <p className="text-[11px] font-bold uppercase tracking-wider text-gray-400 mb-2">Imagem de exibição</p>
                            <div className="aspect-square w-full overflow-hidden rounded-xl bg-gray-100 ring-1 ring-gray-200 flex items-center justify-center text-gray-300">
                                {
                                    displayImage ?
                                        <img src={displayImage} alt="display" className="h-full w-full object-cover" />
                                        : <ImageIcon width="40px" />
                                }
                            </div>
                        </div>
                        <AdminDetails
                            className="flex-1 content-start"
                            columns={1}
                            items={[
                                { label: "Marca", value: watch?.brand },
                                { label: "Modelo", value: watch?.model },
                                { label: "Ano", value: watch?.year },
                                { label: "ID", value: <span className="font-mono text-xs">{watch?.id}</span> },
                            ]}
                        />
                    </div>
                    : <AdminWatchSpecs watch={watch} />
            }
            <AdminToast toast={goodToast} setToast={setGoodToast} message="Banners atualizados!" tone="success" />
            <AdminToast toast={badToast} setToast={setBadToast} message="Erro na operação!" tone="danger" />
        </AdminModal>
    )
}
